export enum SettingGroupType {
    none = 0,
    frontOfficeFacetConfiguration = 1,
    frontOfficeLanguageConfiguration = 2,
    linkedOpenDataConfiguration = 3,
    frontOfficeNotifications = 4,
    frontOfficeSystemNotifications = 5,
    frontOfficeEasyToRead = 6,
    backOfficeSession = 7,
    classifierAuditConfiguration = 8,
}
